import {SharedQuestion} from "./SharedQuestion";

export class PageSharedQuestion extends SharedQuestion {

    isValid():boolean {
        super.isValid();

        return true;
    }

    getValue():IValue {
        return null;
    }

    setValue(value:any) {

    }

    satisfiesValue(currentValues:IValue[], node:IValue):boolean {
        return true;
    }

    isAnswerEmpty(answer: IAnswer): boolean {
        return true;
    }
}